import type React from "react";
import { useState } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { TypingText } from "app/pages/sales-intelligence/modules/ai-agent/components/TypingText/TypingText";

type Props = {
    title: string;
    titleSuffix?: string;
    onDone?: () => void;
    isDisabledTyping?: boolean;
    dataAutomation?: string;
};

export const FormItem: React.FC<React.PropsWithChildren<Props>> = ({
    title,
    titleSuffix,
    onDone,
    isDisabledTyping,
    children,
    dataAutomation,
}) => {
    const [isTitleDone, setIsTitleDone] = useState(isDisabledTyping ? true : false);

    const handleTitleDone = () => {
        setIsTitleDone(true);
        onDone?.();
    };

    return (
        <div data-automation={dataAutomation}>
            <Text
                fontVariant="body1"
                color={colorsPalettes.carbon[400]}
                margin="0 0 4px 0"
                display="block"
            >
                <TypingText
                    text={title}
                    onDone={handleTitleDone}
                    isDisabledTyping={isDisabledTyping}
                />
                {isTitleDone && titleSuffix ? ` ${titleSuffix}` : null}
            </Text>
            {isTitleDone ? children : null}
        </div>
    );
};
